import React, { useEffect, useRef, lazy } from 'react';
import { Star, Quote } from 'lucide-react';
export function Testimonials() {
  const slider1Ref = useRef<HTMLDivElement>(null);
  const slider2Ref = useRef<HTMLDivElement>(null);
  const testimonials = [{
    name: 'Abdullahi',
    role: 'Aspiring Executive Assistant',
    content: 'The Executive Assistant Mastery Course transformed how I think, work, and communicate professionally. It exceeded every expectation.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&h=200&q=80'
  }, {
    name: 'Eunice',
    role: 'Practicing Executive Assistant',
    content: 'This course was an eye-opener. The modules were practical, detailed, and relevant. I now feel more confident in my EA journey.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&h=200&q=80'
  }, {
    name: 'Ayobami',
    role: 'Aspiring Executive Assistant',
    content: 'Nothing short of exceptional. The course broadened my understanding and gave me clarity on how to excel as a world-class EA.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&h=200&q=80'
  }, {
    name: 'Marian',
    role: 'Practicing Nurse',
    content: "Joining SkillzHQ was one of the best decisions I've made. The training reshaped my mindset and equipped me with real, applicable skills.",
    rating: 5,
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&h=200&q=80'
  }, {
    name: 'Adesuyi',
    role: 'Aspiring Executive Assistant',
    content: 'A powerful learning journey. I gained clarity, structure, and practical skills I can apply immediately.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&h=200&q=80'
  }, {
    name: 'Augusta',
    role: 'Aspiring Executive Assistant',
    content: 'This course strengthened my confidence and helped me discover the professional I can become with the right tools.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&h=200&q=80'
  }, {
    name: 'Sonia',
    role: 'Student',
    content: 'The Executive Assistant Mastery Course changed how I organize my tasks, manage my time, and show up professionally.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&h=200&q=80'
  }, {
    name: 'Bethel',
    role: 'Practicing Executive Assistant',
    content: 'Before SkillzHQ I lacked clarity; now I understand what top-tier executive support looks like and how to deliver it.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&h=200&q=80'
  }, {
    name: 'Victoria',
    role: 'Customer Service Representative / NYSC Member',
    content: 'This course helped me reinvent my approach to work. I now think more strategically and communicate with purpose.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&h=200&q=80'
  }, {
    name: 'Lysa',
    role: 'Student',
    content: 'This training elevated my mindset and gave me the confidence to pursue a career as a world-class EA.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&h=200&q=80'
  }];
  // Split testimonials into two rows
  const row1Testimonials = [...testimonials, ...testimonials]; // Double for seamless loop
  const row2Testimonials = [...testimonials.slice().reverse(), ...testimonials.slice().reverse()]; // Reverse for variety
  useEffect(() => {
    const slider1 = slider1Ref.current;
    const slider2 = slider2Ref.current;
    if (!slider1 || !slider2) return;
    let animationId1: number;
    let animationId2: number;
    let position1 = 0;
    let position2 = 0;
    const speed = 0.3;
    const animate1 = () => {
      position1 -= speed;
      const cardWidth = 380;
      const totalWidth = cardWidth * testimonials.length;
      if (Math.abs(position1) >= totalWidth) {
        position1 = 0;
      }
      slider1.style.transform = `translateX(${position1}px)`;
      animationId1 = requestAnimationFrame(animate1);
    };
    const animate2 = () => {
      position2 += speed; // Opposite direction
      const cardWidth = 380;
      const totalWidth = cardWidth * testimonials.length;
      if (position2 >= totalWidth) {
        position2 = 0;
      }
      slider2.style.transform = `translateX(${position2}px)`;
      animationId2 = requestAnimationFrame(animate2);
    };
    animationId1 = requestAnimationFrame(animate1);
    animationId2 = requestAnimationFrame(animate2);
    return () => {
      cancelAnimationFrame(animationId1);
      cancelAnimationFrame(animationId2);
    };
  }, [testimonials.length]);
  return <section className="mb-12" data-id="element-403">
      <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-404">
        What Our Students Say
      </h2>

      {/* Two rows of continuous sliders */}
      <div className="space-y-4 overflow-hidden" data-id="element-405">
        {/* Row 1 - Scrolling left */}
        <div className="relative" data-id="element-406">
          <div className="absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" data-id="element-407" />
          <div className="absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" data-id="element-408" />

          <div className="overflow-hidden" data-id="element-409">
            <div ref={slider1Ref} className="flex gap-4" style={{
            width: 'fit-content'
          }} data-id="element-410">
              {row1Testimonials.map((testimonial, index) => <div key={index} className="flex-shrink-0 bg-gradient-to-br from-blue-50 to-white rounded-xl p-6 border border-blue-100 shadow-md hover:shadow-lg transition-shadow duration-300" style={{
              width: '360px'
            }} data-id="element-411">
                  <div className="flex items-center gap-2 mb-3" data-id="element-412">
                    <Quote className="w-5 h-5 text-blue-600 flex-shrink-0" data-id="element-413" />
                    <div className="flex gap-1" data-id="element-414">
                      {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-415" />)}
                    </div>
                  </div>
                  <p className="text-gray-700 text-sm italic mb-4 leading-relaxed" data-id="element-416">
                    "{testimonial.content}"
                  </p>
                  <div data-id="element-417">
                    <p className="font-bold text-gray-900 text-base" data-id="element-418">
                      {testimonial.name}
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-419">{testimonial.role}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        {/* Row 2 - Scrolling right */}
        <div className="relative" data-id="element-420">
          <div className="absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" data-id="element-421" />
          <div className="absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" data-id="element-422" />

          <div className="overflow-hidden" data-id="element-423">
            <div ref={slider2Ref} className="flex gap-4" style={{
            width: 'fit-content'
          }} data-id="element-424">
              {row2Testimonials.map((testimonial, index) => <div key={index} className="flex-shrink-0 bg-gradient-to-br from-green-50 to-white rounded-xl p-6 border border-green-100 shadow-md hover:shadow-lg transition-shadow duration-300" style={{
              width: '360px'
            }} data-id="element-425">
                  <div className="flex items-center gap-2 mb-3" data-id="element-426">
                    <Quote className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-427" />
                    <div className="flex gap-1" data-id="element-428">
                      {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-429" />)}
                    </div>
                  </div>
                  <p className="text-gray-700 text-sm italic mb-4 leading-relaxed" data-id="element-430">
                    "{testimonial.content}"
                  </p>
                  <div data-id="element-431">
                    <p className="font-bold text-gray-900 text-base" data-id="element-432">
                      {testimonial.name}
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-433">{testimonial.role}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>

      {/* FAQs Section */}
      <div className="mt-12" data-id="element-434">
        <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-435">
          Frequently Asked Questions
        </h2>

        <div className="space-y-4" data-id="element-436">
          <details className="bg-white rounded-xl p-6 border-2 border-gray-100 hover:border-blue-200 transition-colors duration-300 group" data-id="element-437">
            <summary className="font-bold text-gray-900 cursor-pointer list-none flex items-center justify-between" data-id="element-438">
              <span data-id="element-439">What is the course schedule like?</span>
              <span className="text-blue-600 group-open:rotate-180 transition-transform duration-300" data-id="element-440">
                ▼
              </span>
            </summary>
            <p className="text-gray-700 mt-4 leading-relaxed" data-id="element-441">
              The course is self-paced within a 6-week cohort structure. You'll
              have access to pre-recorded lessons, live Q&A sessions, and
              practical assignments. We recommend dedicating 5-8 hours per week
              to get the most out of the program.
            </p>
          </details>

          <details className="bg-white rounded-xl p-6 border-2 border-gray-100 hover:border-blue-200 transition-colors duration-300 group" data-id="element-442">
            <summary className="font-bold text-gray-900 cursor-pointer list-none flex items-center justify-between" data-id="element-443">
              <span data-id="element-444">Do I need prior experience to enroll?</span>
              <span className="text-blue-600 group-open:rotate-180 transition-transform duration-300" data-id="element-445">
                ▼
              </span>
            </summary>
            <p className="text-gray-700 mt-4 leading-relaxed" data-id="element-446">
              No prior EA experience is required! This course is designed for
              both beginners and those looking to advance their careers. We
              start with fundamentals and progress to advanced executive support
              strategies.
            </p>
          </details>

          <details className="bg-white rounded-xl p-6 border-2 border-gray-100 hover:border-blue-200 transition-colors duration-300 group" data-id="element-447">
            <summary className="font-bold text-gray-900 cursor-pointer list-none flex items-center justify-between" data-id="element-448">
              <span data-id="element-449">Will I receive a certificate?</span>
              <span className="text-blue-600 group-open:rotate-180 transition-transform duration-300" data-id="element-450">
                ▼
              </span>
            </summary>
            <p className="text-gray-700 mt-4 leading-relaxed" data-id="element-451">
              Yes! Upon successful completion of all course modules and
              assignments, you'll receive a recognized Executive Assistant
              Certificate from SkillzHQ that you can add to your resume and
              LinkedIn profile.
            </p>
          </details>

          <details className="bg-white rounded-xl p-6 border-2 border-gray-100 hover:border-blue-200 transition-colors duration-300 group" data-id="element-452">
            <summary className="font-bold text-gray-900 cursor-pointer list-none flex items-center justify-between" data-id="element-453">
              <span data-id="element-454">What tools will I learn to use?</span>
              <span className="text-blue-600 group-open:rotate-180 transition-transform duration-300" data-id="element-455">
                ▼
              </span>
            </summary>
            <p className="text-gray-700 mt-4 leading-relaxed" data-id="element-456">
              You'll gain hands-on experience with essential EA tools including
              calendar management systems, project management platforms,
              communication tools, and document management systems. We focus on
              industry-standard tools used by top organizations.
            </p>
          </details>

          <details className="bg-white rounded-xl p-6 border-2 border-gray-100 hover:border-blue-200 transition-colors duration-300 group" data-id="element-457">
            <summary className="font-bold text-gray-900 cursor-pointer list-none flex items-center justify-between" data-id="element-458">
              <span data-id="element-459">Is there job placement support?</span>
              <span className="text-blue-600 group-open:rotate-180 transition-transform duration-300" data-id="element-460">
                ▼
              </span>
            </summary>
            <p className="text-gray-700 mt-4 leading-relaxed" data-id="element-461">
              Yes! We provide career support through our recruitment partners
              and help you apply for internship or entry-level EA opportunities.
              You'll also build a professional portfolio during the course to
              showcase to potential employers.
            </p>
          </details>
        </div>
      </div>
    </section>;
}